module.exports = __webpack_public_path__ + "assets/img/saules-elektriniu-parkas.effb1bc1.webp";